module.exports = __webpack_public_path__ + "static/img/eight_icon2.ad8fd4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/eight_icon2.png
// module id = r0Cf
// module chunks = 12